module.exports = __webpack_public_path__ + "static/media/Privacy-7.99f79a9d.png";